<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" title="检验拒收" keywordPlaceholder="检验项目名称、床位号" hide-search-dialog>
    <template slot="search">
      <el-switch v-model="ifAll" active-text="全部" inactive-text="未处理" @change="query()"></el-switch>
    </template>
    
    <el-table-column label="操作 " key="action" align="center" width="100">
      <template #default="{ row }">
        <el-popconfirm v-if="!row.nextId" title="确定要重新送检吗？" @confirm="processWarning(row, true)" class="right-pad" >
          <el-button slot="reference" type="primary" size="mini" icon="el-icon-takeaway-box" circle plain title="重新送检" />
        </el-popconfirm>
        <el-button v-if="row.ifWarning" slot="reference" type="warning" size="mini" icon="el-icon-document-checked" circle plain title="已读" @click="processWarning(row, false)" />
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="state" key="state" align="center" min-width="100" column-key="state">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state == '待接收'" type="info" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '待检验'" type="primary" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '样本拒收'" type="warning" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '报告发出'" type="success" size="small" hit effect="dark">{{ row.state }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="床位号" prop="bedNo" key="bedNo" min-width="100"></el-table-column>
    <el-table-column label="患者姓名" prop="patientName" key="patientName" min-width="120"></el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" align="center" min-width="80">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" align="center" min-width="80"></el-table-column>
    <el-table-column label="检验项目" prop="name" key="name" min-width="260"></el-table-column>
    <el-table-column label="拒收原因" prop="lisReceiveMemo" key="lisReceiveMemo" align="center" min-width="260">
      <template slot-scope="{ row }">
        <el-tag type="danger" size="small" hit effect="plain">{{ row.lisReceiveMemo }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="开嘱医生" prop="issuedDoctorName" key="issuedDoctorName" min-width="100"></el-table-column>
    <el-table-column label="申请时间" prop="issuedTime" key="issuedTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="执行护士" prop="execNurseName" key="execNurseName" min-width="100"></el-table-column>
    <el-table-column label="接收人" prop="lisReceiveUserName" key="lisReceiveUserName" min-width="100"></el-table-column>
    <el-table-column label="接收时间" prop="lisReceiveTime" key="lisReceiveTime" align="center" min-width="160"></el-table-column>
  </hic-list-page>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    data() {
      return {
        meta: {
          loading: false,
        },
        condition: {
          sort: "issuedTime",
          asc: false,
          ids: [],
          pageSize: 20,
          pageIndexOnView: 1,
          state: '样本拒收',
          ifWarning: true,
          warningType: 1,
        },
        entities: {},
        ifAll: false,
      }
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
    },
    methods: {
      query() {
        this.meta.loading = true;
        this.condition.ifWarning = this.ifAll ? null : true;
        api.LisRecord.getWarning(this.condition).then((res) => {
            this.$set(this, "entities", res);
          }).finally(() => {
            this.meta.loading = false;
          });
      },
      processWarning(row, next) {
         if (next) {
          row.nextId = 1;
         }
         api.LisRecord.processWarning(row).then((res) => {
            if (next) {
              this.$message.success("重新送检成功！");
            }
            this.query();
          }).catch((err) => {
            this.$message.error(err.message || err);
          });
      }
    }
  }
</script>
<style>
.el-tag {
  white-space: pre-wrap;
  height: auto;
}
</style>